/** Addendum: the events/media trade_item_id format is always `{gln}-{gtin}-{targetMarket}`. */
const TRADE_ITEM_ID_PATTERN = /^(\d{13})-(\d{8,14})-(\d{3})$/;

export interface ParsedTradeItemId {
  gln: string;
  gtin: string;
  targetMarket: string;
}

export function parseTradeItemId(tradeItemId: string): ParsedTradeItemId | null {
  const match = TRADE_ITEM_ID_PATTERN.exec(tradeItemId);
  if (match == null) return null;
  return { gln: match[1]!, gtin: match[2]!, targetMarket: match[3]! };
}
